import { Component, effect, inject } from '@angular/core';
import { SharedSignalsService } from '../../../common/services/shared-signals.service';
import { TranslationService } from '../../../common/services/translation.service';

@Component({
  selector: 'taly-sell-with-taly',
  templateUrl: './sell-with-taly.component.html',
  styleUrls: ['./sell-with-taly.component.scss'],
  standalone: false,
})
export class SellWithTalyComponent {
  transferSignal = inject(SharedSignalsService);
  public translationService = inject(TranslationService);

  textDirection!: string;

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();
    });
  }
}
